/**
 * An error thrown by our fetch implementation. It allows for inspection
 * of a response if present. Typically thrown when response has a status
 * code > 399 and <= 599, but could also be thrown when connectivity is
 * an issue.
 */
class FetchError extends Error {
  /**
   * Fetch API response.
   */
  public response?: Response
  /**
   * Status code for an HTTP response.
   */
  public status: number
  /**
   * Original error that was caught, if any.
   */
  public originalError?: any
  /**
   * The raw response body, when `fetchJson` rejects a 2xx HTML response via its
   * content-type guard. Non-ok HTTP failures keep putting the raw body on `message`;
   * read `message`, not this, to inspect those bodies.
   */
  public body?: string

  public constructor(status: number, msg: string, response?: Response, originalError?: any, body?: string) {
    super(msg)
    this.status = status
    this.response = response
    this.originalError = originalError
    this.body = body
  }
}

export default FetchError
